import { Box, Flex, Text } from '@chakra-ui/react'
import { cnpjMask } from '../../../utils/cnpjMask'

export function Innovation({ empresa }) {
  return (
    <Box
      gridColumn={{
        base: 'span 12',
        md: 'span 8',
      }}
      border="1px solid #cfcfcf"
    >
      <Text textAlign="center" color="#1D1D1D" bg="#cfcfcf">
        INNOVATION BRINDES
      </Text>

      <Flex flexDir="column" gap={1} p={3}>
        <Text>
          <b>Razão Social:</b> {empresa.razao_social}
        </Text>
        <Text>
          <b>CNPJ</b>: {cnpjMask(empresa.cpf_cpnj)}
        </Text>
        <Text>
          <b>IE:</b> {empresa.ie}
        </Text>
      </Flex>
    </Box>
  )
}
